import React, {useState} from 'react';

import { DocumentViewer as DocViewer } from 'react-documents';
import {FastForward, FastRewind} from "@material-ui/icons";
import {Grid, IconButton, InputLabel} from "@material-ui/core";

import {Alert, FormDialog, Text} from '../../controls';


const DocumentViewer = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;
  const [dialogStates, setDialogStates] = useState(props.dialogStates);
  const [documents] = useState(props.documents);
  const [currentDocument, setCurrentDocument] = useState(0);

  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  const handleDocumentChange = (direction) => {
    if (documents && Array.isArray(documents) && documents.length > 0) {
      if (direction < 0) {
        if (currentDocument > 0) {
          setCurrentDocument(currentDocument + direction);
        }
      }
      else {
        if (currentDocument < documents.length-1) {
          setCurrentDocument(currentDocument + direction);
        }
      }
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={`${dialogStates.title} (${currentDocument + 1} of ${documents.length})`}
        message=""
        open={dialogStates.showDialog}
        record={{}}
        dialogOptions={{width: "md", maxWidth: "md", fullWidth: true,  height: "inherit"}}
        classes={classes}
        buttons = {{
          // addFunction: {icon: "add_circle", key: "Add Function", label: "Add Function", color: "primary"},
          // save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {

          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
            if (props.close)
              props.close();
          }
        }}

      >
        <Grid container checkChildren={false} spacing={3}>
          <Grid item xs={1} checkChildren={false}>
            <div style={{width:"50px", marginRight:10, marginLeft:10, height: 45}}>
              <IconButton
                disabled={currentDocument === 0}
                color="primary"
                onClick={() => { handleDocumentChange(-1) }}
              >
                <FastRewind fontSize="large" />
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={2} checkChildren={false}>
            <div>
              <InputLabel shrink>
                Description
              </InputLabel>

              <Text
                style={{width: "100%", marginTop: 2, display: "inline-block"}}
                value={documents[currentDocument].documentDescription}
              />
            </div>
          </Grid>
          <Grid item xs={7} checkChildren={false}>
            <div>
              <InputLabel shrink>
                File Name
              </InputLabel>

              <Text
                style={{width: "100%", marginTop: 2, display: "inline-block"}}
                //defaultValue={header.fileName}
                value={documents[currentDocument].fileName}
              />
            </div>
          </Grid>
          <Grid item xs={1} checkChildren={false}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Type
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  value={documents[currentDocument].fileType ? documents[currentDocument].fileType.toUpperCase() : ""}
                />
              </div>
          </Grid>
          <Grid item xs={1} checkChildren={false}>
            <div style={{width:"50px", marginRight:10, marginLeft:10, height: 45}}>
              <IconButton
                disabled={currentDocument >= (documents.length - 1)}
                color="primary"
                onClick={() => { handleDocumentChange(1) }}
              >
                <FastForward fontSize="large"/>
              </IconButton>
            </div>
          </Grid>
        </Grid>

        <Grid container checkChildren={false} spacing={3}>
          <Grid item xs={12} checkChildren={false}>
              <div style={{width: "100%", overflow: "scroll", maxHeight: 700, objectFit: "contain"}}>
                {["gif", "jpg", "jpeg", "png"].includes(documents[currentDocument].fileType.toLowerCase())
                  ?
                    <img src={documents[currentDocument].uri} style={{width: "100%", height: "100%",  objectFit: "contain"}} />
                  :
                    <DocViewer
                      style={{ height: '80vh', width: '100%' }}
                      queryParams="hl=EN"
                      url={documents[currentDocument].uri}
                      viewer={"google"}
                      googleCheckContentLoaded={true}
                      googleCheckInterval={3000}
                      googleMaxChecks={3}
                      //overrideLocalhost="https://angular-doc-viewer.firebaseapp.com/"
                      //viewerUrl={selectedViewer.viewerUrl}
                      //loaded={()=>(console.log("Loaded ...................................................................................."))}
                    ></DocViewer>
                }
              </div>
          </Grid>
        </Grid>
      </FormDialog>
    )
  } else {
    return (<></>);
  }

}

export default DocumentViewer;
